<template>
  <div class="animated fadeIn">
     <div id='loadingmessage' style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;" v-if="loading">
    <p style="position: absolute; color: White; top: 40%; left: 50%;">
      <img src='../assets/loader.gif'/>
    </p>
  </div>
    <b-row >
      <b-col cols="12" sm="6" lg="3">
        <b-card :no-body="true" footer-class="px-3 py-2">
          <b-card-body class="p-3 clearfix pt-4 pb-2">
            <div class="float-left">
                <i class="fa fa-cogs text-info  font-5xl"></i>
              </div>
          <div class="float-right">
                <p class="card-text text-right mb-0 pb-0">Users</p>
                <div class="pt-0" >
                  <h3 class=" font-weight-bold text-right mb-0 mt-0 pt-0">{{data.usercount}}</h3>
                </div>
          </div>
          </b-card-body>
          <div  class="pb-4 pl-2">
            <b-link class="font-weight-bold font-xs btn-block " href="/userlist">View Details </b-link>
          </div>
        </b-card>
      </b-col>
      <b-col cols="12" sm="6" lg="3">
        <b-card :no-body="true" footer-class="px-3 py-2">
          <b-card-body class="p-3 clearfix pt-4 pb-2">
            <div class="float-left">
                <i class="fa fa-cogs text-info  font-5xl"></i>
              </div>
          <div class="float-right">
                <p class="card-text text-right mb-0 pb-0">Turtle Count</p>
                <div class="pt-0" >
                  <h3 class=" font-weight-bold text-right mb-0 mt-0 pt-0">{{data.turtlecount}}</h3>
                </div>
          </div>
          </b-card-body>
          <div  class="pb-4 pl-2">
            <b-link class="text-muted font-weight-bold font-xs btn-block " href="/listturtles">View Details </b-link>
          </div>
        </b-card>
      </b-col>
      <b-col cols="12" sm="6" lg="3">
        <b-card :no-body="true" footer-class="px-3 py-2">
          <b-card-body class="p-3 clearfix pt-4 pb-2">
            <div class="float-left">
                <i class="fa fa-cogs text-info  font-5xl"></i>
              </div>
          <div class="float-right">
                <p class="card-text text-right mb-0 pb-0">Sightings</p>
                <div class="pt-0" >
                  <h3 class=" font-weight-bold text-right mb-0 mt-0 pt-0">{{data.sightingscount}}</h3>
                </div>
          </div>
          </b-card-body>
          <div  class="pb-4 pl-2">
            <b-link class="text-muted font-weight-bold font-xs btn-block " href="/reportlist">View Details </b-link>
          </div>
        </b-card>
      </b-col>
    
      <b-col cols="12" sm="6" lg="3">
        <b-card :no-body="true" footer-class="px-3 py-2">
          <b-card-body class="p-3 clearfix pt-4 pb-2">
            <div class="float-left">
                <i class="fa fa-cogs text-info  font-5xl"></i>
              </div>
          <div class="float-right">
                <p class="card-text text-right mb-0 pb-0">Rescue Centers</p>
                <div class="pt-0" >
                  <h3 class=" font-weight-bold text-right mb-0 mt-0 pt-0">{{data.rescuecentercount}}</h3>
                </div>
          </div>
          </b-card-body>
          <div  class="pb-4 pl-2">
            <b-link class="text-muted font-weight-bold font-xs btn-block " href="/rescuecntloc">View Map </b-link>
          </div>
        </b-card>
      </b-col>
      <b-col cols="12" sm="6" lg="3">
        <b-card :no-body="true" footer-class="px-3 py-2">
          <b-card-body class="p-3 clearfix pt-4 pb-2">
            <div class="float-left">
                <i class="fa fa-cogs text-info  font-5xl"></i>
              </div>
          <div class="float-right">
                <p class="card-text text-right mb-0 pb-0">Sightings Location</p>
                <div class="pt-0" >
                  <h3 class=" font-weight-bold text-right mb-0 mt-0 pt-0">{{data.sightingscount}}</h3>
                </div>
          </div>
          </b-card-body>
          <div  class="pb-4 pl-2">
            <b-link class="text-muted font-weight-bold font-xs btn-block " href="/sightingsloc">view in map </b-link>
          </div>
        </b-card>
      </b-col>
      <b-col cols="12" sm="6" lg="3">
        <b-card :no-body="true" footer-class="px-3 py-2">
          <b-card-body class="p-3 clearfix pt-4 pb-2">
            <div class="float-left">
                <i class="fa fa-cogs text-info  font-5xl"></i>
              </div>
          <div class="float-right">
                <p class="card-text text-right mb-0 pb-0">Rescue Count</p>
                <div class="pt-0" >
                  <h3 class="text-muted text-uppercase font-weight-bold text-right mb-0 mt-0 pt-0">{{data.rescuecount}}</h3>
                </div>
          </div>
          </b-card-body>
          <div  class="pb-4 pl-2">
            <b-link class="text-muted font-weight-bold font-xs btn-block " href="/rescue">View More </b-link>
          </div>
        </b-card>
      </b-col>
      <b-col cols="12" sm="6" lg="3">
        <b-card :no-body="true" footer-class="px-3 py-2">
          <b-card-body class="p-3 clearfix pt-4 pb-2">
            <div class="float-left">
                <i class="fa fa-cogs text-info  font-5xl"></i>
              </div>
          <div class="float-right">
                <p class="card-text text-right mb-0 pb-0">Observation Count</p>
                <div class="pt-0" >
                  <h3 class=" font-weight-bold text-right mb-0 mt-0 pt-0">{{data.observationcount}}</h3>
                </div>
          </div>
          </b-card-body>
          <div  class="pb-4 pl-2">
            <b-link class="text-muted font-weight-bold font-xs btn-block " href="/observation">View More </b-link>
          </div>
        </b-card>
      </b-col>
    
    </b-row>
    <sightingslocdash></sightingslocdash>
 <listturtles1></listturtles1>
  
  </div>
</template>

<script>
import CardLine1ChartExample from './dashboard/CardLine1ChartExample'
import CardLine2ChartExample from './dashboard/CardLine2ChartExample'
import CardLine3ChartExample from './dashboard/CardLine3ChartExample'
import CardBarChartExample from './dashboard/CardBarChartExample'
import MainChartExample from './dashboard/MainChartExample'
import SocialBoxChartExample from './dashboard/SocialBoxChartExample'
import CalloutChartExample from './dashboard/CalloutChartExample'
import listturtles1 from './users/listturtles1'
import sightingslocdash from './users/sightingslocdash'
import { Callout } from '@coreui/vue'
import axios from 'axios'
export default {
  name: 'dashboard',
  components: {
    Callout,
    CardLine1ChartExample,
    CardLine2ChartExample,
    CardLine3ChartExample,
    CardBarChartExample,
    MainChartExample,
    SocialBoxChartExample,
    CalloutChartExample,
    listturtles1,
    sightingslocdash
  },
  data: function () {
    return {
      selected: 'Month',
      tableFields: {
        firstname: {
          label: 'Name'
        },
         email: {
          label: 'Email'
        },
         amount: {
          label: 'Amount',
          class: 'text-center'
        },
        mobile: {
          label: 'Mobile No.'
        },
        payment_status: {
          label: 'Status',
          class: 'text-center'
        },
        paymentgateway: {
          label: 'PG Used'
        }
      },
      stats: '',
      statsmonth: '',
      lastten: [],
      loading: false,
      data:[],
    }
  },
   mounted: function () {
    this.getlist()
    // this.loadStats()
    // this.loadStatsMonth()
    // this.loadUser()
  },
  methods: {
    //     authCheck(){
    //   axios({
    //     url: 'http://18.191.40.18/isLoggedIn',
    //     method: 'GET',
    //     headers: {
    //                 'x-auth-token': localStorage.getItem("token")
    //             },
    //   }).then(response => {
    //     if(response.data.status == true){
    //       // console.log('sdf')
    //     }
    //     else{
    //        localStorage.removeItem('token')
    //       localStorage.removeItem('username')
    //       localStorage.removeItem('is_admin')
    //       localStorage.removeItem('id')
    //       store.commit('logoutUser')
    //       this.$router.push({ name: 'login' })
    //     }
    //   }).catch(e => {
    //      localStorage.removeItem('token')
    //       localStorage.removeItem('username')
    //       localStorage.removeItem('is_admin')
    //       localStorage.removeItem('id')
    //       store.commit('logoutUser')
    //       this.$router.push({ name: 'login' })
    //   })
    // },
    getlist () {
      this.loading = true
      var att = {}
     
      att['token'] = localStorage.getItem('token')
      axios({
        method: 'GET',
        url: '/dashboard/admin',
        data: att,
        
      })
        .then(response => {
          this.loading = false;

          if (response.data.status === true) {
            this.data = response.data.data;
            this.loading = false;
          } else if (response.data.status === false) {
            this.loading = false;
          }
        })
        .catch(e => {
          this.loading = false;
          this.errors.push(e);
          this.msg = "failed";
        });
    },
    loadStats () {
      this.loading = true
      axios({
        url: 'https://wtiadmin.in/Donation/stats',
        method: 'POST'
      }).then(response => {
        this.stats = response.data.stats
      }).catch(e => {
        this.errors.push(e)
        this.loading = false
      })
    },
      loadStatsMonth () {
      this.loading = true
      axios({
        url: 'https://wtiadmin.in/Donation/adminreport/thismonth',
        method: 'GET'
      }).then(response => {
        this.statsmonth = response.data.totalstats
         this.loading = false
      }).catch(e => {
        this.errors.push(e)
        this.loading = false
      })
    },
    loadUser () {
      this.loading = true
      axios({
        url: 'https://wtiadmin.in/Donation/lastten',
        method: 'POST'
      }).then(response => {
        this.lastten = response.data.data
      }).catch(e => {
        this.errors.push(e)
        this.loading = false
      })
    },
    
    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },
    flag (value) {
      return 'flag-icon flag-icon-' + value
    },
      getBadge (status) {
      return status === 'sucess' ? 'success'
        : status === 'initiate' ? 'secondary'
          : status === 'progress' ? 'warning'
            : status === 'failure' ? 'danger' : 'primary'
    },
    userLink (id) {
      return `users/${id.toString()}`
    },
    rowClicked (item) {
      const userLink = this.userLink(item._id)
      this.$router.push({path: userLink})
    }
  }
}
</script>
<style>
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
